import { createFileRoute } from '@tanstack/react-router';

// Define the route for the 404 page
export const Route = createFileRoute('/_404')({});
